import { object, string, array } from 'yup';

import { ERROR_MESSAGES, ORDER_TYPE_NAMES } from '../constants';

export const initialValues = {
  orderTypes: [],
  atOnceStart: '',
  atOnceEnd: '',
  futuresCrd: '',
  futuresStart: '',
  futuresEnd: '',
  forecastCrd: '',
  forecastStart: '',
  forecastEnd: ''
};

const {
  orderTypes,
  atOnceStart,
  atOnceEnd,
  futuresCRD,
  futuresStart,
  futuresEnd,
  forecastCRD,
  forecastStart,
  forecastEnd,
  dateRange
} = ERROR_MESSAGES;

export const validationSchema = object().shape({
  orderTypes: array().min(1, orderTypes),
  atOnceStart: string().when('orderTypes', {
    is: orderTypes => orderTypes.includes(ORDER_TYPE_NAMES.ATONCE),
    then: string().required(atOnceStart)
  }),
  atOnceEnd: string()
    .when('orderTypes', {
      is: orderTypes => orderTypes.includes(ORDER_TYPE_NAMES.ATONCE),
      then: string().required(atOnceEnd)
    })
    .test('atOnceEnd', ERROR_MESSAGES.dateRange, (value, context) =>
      context?.parent?.orderTypes.includes(ORDER_TYPE_NAMES.ATONCE) ? context?.parent?.atOnceStart <= value : true
    ),
  futuresCrd: string().when('orderTypes', {
    is: orderTypes => orderTypes.includes(ORDER_TYPE_NAMES.FUTURES),
    then: string().required(futuresCRD)
  }),
  futuresStart: string().when('orderTypes', {
    is: orderTypes => orderTypes.includes(ORDER_TYPE_NAMES.FUTURES),
    then: string().required(futuresStart)
  }),
  futuresEnd: string()
    .when('orderTypes', {
      is: orderTypes => orderTypes.includes(ORDER_TYPE_NAMES.FUTURES),
      then: string().required(futuresEnd)
    })
    .test('futuresEnd', ERROR_MESSAGES.dateRange, (value, context) =>
      context?.parent?.orderTypes.includes(ORDER_TYPE_NAMES.FUTURES) ? context?.parent?.futuresStart <= value : true
    ),
  forecastCrd: string().when('orderTypes', {
    is: orderTypes => orderTypes.includes(ORDER_TYPE_NAMES.FORECAST),
    then: string().required(forecastCRD)
  }),
  forecastStart: string().when('orderTypes', {
    is: orderTypes => orderTypes.includes(ORDER_TYPE_NAMES.FORECAST),
    then: string().required(forecastStart)
  }),
  forecastEnd: string()
    .when('orderTypes', {
      is: orderTypes => orderTypes.includes(ORDER_TYPE_NAMES.FORECAST),
      then: string().required(forecastEnd)
    })
    .test('forecastEnd', dateRange, (value, context) =>
      context?.parent?.orderTypes.includes(ORDER_TYPE_NAMES.FORECAST) ? context?.parent?.forecastStart <= value : true
    )
});
